var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog, width: "50%" },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "subbox" }, [
                  _vm._v(
                    "项目删除后可在“ 我的-回收站 ”中查看，不可进行操作，不纳入统计。可随时取消项目删除，正常使用该项目。"
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog2 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "copy_conyent" }, [
                  _c("div", [
                    _c("div", { staticClass: "copy_label" }, [
                      _vm._v("项目名称"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "copy_value" },
                      [
                        _c("el-input", {
                          attrs: { autofocus: true, placeholder: "点击添加" },
                          model: {
                            value: _vm.dialog2.proname,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialog2, "proname", $$v)
                            },
                            expression: "dialog2.proname",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "copy_label" }, [
                      _vm._v("项目计划时间"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "copy_value",
                        staticStyle: { width: "70%" },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "点击添加",
                            "value-format": "yyyy/MM/dd HH:mm:ss",
                            format: "yyyy/MM/dd",
                            clearable: false,
                            "picker-options": _vm.pickerOptions,
                          },
                          on: { focus: _vm.focusStartChange },
                          model: {
                            value: _vm.dialog2.planStartDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialog2, "planStartDate", $$v)
                            },
                            expression: "dialog2.planStartDate",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: { color: "#909090", margin: "0 10px" },
                          },
                          [_vm._v("-")]
                        ),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            placeholder: "点击添加",
                            "value-format": "yyyy/MM/dd HH:mm:ss",
                            format: "yyyy/MM/dd",
                            clearable: false,
                            "picker-options": _vm.pickerOptions1,
                          },
                          on: { focus: _vm.focusEndChange },
                          model: {
                            value: _vm.dialog2.planEndDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialog2, "planEndDate", $$v)
                            },
                            expression: "dialog2.planEndDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "copy_label" }, [
                      _vm._v("项目简介"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "copy_value" },
                      [
                        _c("Describe", {
                          attrs: { describes: _vm.dialog2.describes },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "copy_label" }, [
                      _vm._v("项目标签"),
                    ]),
                    _c("div", { staticClass: "copy_value" }, [
                      _c(
                        "div",
                        { staticClass: "copy_tags" },
                        [
                          _vm._l(_vm.dialog2.labelList, function (tag, index) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.dialog2.labelList &&
                                      _vm.dialog2.labelList.length > 0,
                                    expression:
                                      "dialog2.labelList&&dialog2.labelList.length>0",
                                  },
                                ],
                                key: index,
                                staticClass: "copy_tags_box",
                              },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    staticStyle: { "margin-right": "16px" },
                                    style:
                                      "color:" +
                                      tag.color +
                                      ";background:" +
                                      _vm.convertHex(tag.color, 10),
                                    attrs: { type: "warning" },
                                  },
                                  [_vm._v(_vm._s(tag.labelName))]
                                ),
                                _c("i", {
                                  staticClass: "iconfont icon-shanchu del_icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.delTagsChange(tag)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom",
                                width: "540",
                                trigger: "click",
                              },
                            },
                            [
                              _c("TagsList", {
                                attrs: {
                                  "tags-objects": _vm.tagsObject1,
                                  "tag-lists": _vm.tagList,
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "iconfont icon-jiahao2fill add_icon",
                                style:
                                  _vm.dialog2.labelList &&
                                  _vm.dialog2.labelList.length > 0
                                    ? "margin: 0 24px;"
                                    : "margin: 0",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogCopyHeight },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "desc_boxs" }, [
                  _c("div", { staticStyle: { height: "562px" } }, [
                    _c("div", { staticClass: "tt" }, [
                      _c("div", { staticClass: "task-name" }, [
                        _vm._v("项目编号"),
                      ]),
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogCopyHeight.proNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogCopyHeight, "proNumber", $$v)
                              },
                              expression: "dialogCopyHeight.proNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      [
                        _c("div", { staticClass: "seleTime" }, [
                          _vm._v("计划时间"),
                        ]),
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.dialogCopyHeight.dateType,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogCopyHeight, "dateType", $$v)
                              },
                              expression: "dialogCopyHeight.dateType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("保留所有任务起止时间"),
                            ]),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("清空所有新任务的起止时间"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("所有计划时间顺延 "),
                              _c(
                                "span",
                                { staticClass: "aa" },
                                [
                                  _c("el-input", {
                                    on: { blur: _vm.putOffBlur },
                                    model: {
                                      value: _vm.dialogCopyHeight.putOff,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dialogCopyHeight,
                                          "putOff",
                                          $$v
                                        )
                                      },
                                      expression: "dialogCopyHeight.putOff",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" 天 "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", [
                      _c("div", { staticClass: "seleCopy" }, [
                        _vm._v("复制选项"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "sele-copy" },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.dialogCopyHeight.checkList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dialogCopyHeight,
                                    "checkList",
                                    $$v
                                  )
                                },
                                expression: "dialogCopyHeight.checkList",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: "1" } }, [
                                _vm._v("任务"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "2" } }, [
                                _vm._v("文件"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "3" } }, [
                                _vm._v("标签"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "4" } }, [
                                _vm._v("关注人"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "5" } }, [
                                _vm._v("关联关系"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog3 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "archive_content" }, [
                  _vm._v(_vm._s(_vm.dialog3.desc)),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog4 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_box" }, [
                  _c("div", { staticClass: "cover_left" }, [
                    _c("div", { staticClass: "cover_title" }, [
                      _vm._v("系统封面"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "cover_list" },
                      _vm._l(_vm.coverImgList, function (item, index) {
                        return _c("div", { key: index }, [
                          _c("img", {
                            staticClass: "cover_img",
                            attrs: { src: item.url },
                            on: {
                              click: function ($event) {
                                return _vm.coverImg(item)
                              },
                            },
                          }),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "cover_right" }, [
                    _c("div", { staticClass: "cover_title" }, [
                      _vm._v("自定义封面"),
                    ]),
                    _c("div", { staticClass: "cover_select" }, [
                      _c("div", [_vm._v("预览")]),
                      _c("div", { staticStyle: { margin: "0 17px" } }, [
                        _c("div", { staticClass: "preview_img" }, [
                          !_vm.coverImgInfo_.url
                            ? _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: "https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png",
                                },
                              })
                            : _vm._e(),
                          _vm.coverImgInfo_.url
                            ? _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: { src: _vm.coverImgInfo_.url },
                                on: { error: _vm.setDefaultImage },
                              })
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "“upload”",
                                staticClass: "upload-demo",
                                attrs: {
                                  action:
                                    "https://app117677.eapps.dingtalkcloud.com/scpcm/file/fileUpload",
                                  "show-file-list": false,
                                  headers: _vm.config,
                                  accept: ".jpg,.jpeg,.png,.JPG,.JPEG",
                                  data: { id: _vm.proid },
                                  "on-success": _vm.successFile,
                                  "before-upload": _vm.beforeUpload,
                                  "on-progress": _vm.progress,
                                  disabled: !_vm.fileButten,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "162px",
                                      "text-align": "center",
                                      display: "flex",
                                      "justify-content": "center",
                                    },
                                    attrs: { type: "primary" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-daochu upload_icon",
                                      staticStyle: {
                                        "font-size": "15px",
                                        padding: "0 2px",
                                      },
                                    }),
                                    _vm._v(" 自定义封面 "),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "cover_text",
                            staticStyle: { "margin-top": "11px" },
                          },
                          [_vm._v("建议尺寸：504 X 282")]
                        ),
                        _c("div", { staticClass: "cover_text" }, [
                          _vm._v("文件大小：5M以内"),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }